import CredentialsProvider from 'next-auth/providers/credentials'

import type {AuthOptions} from 'next-auth'

function decodeJwt(token: string): DecodedJwt | null {
  try {
    const payload = token.split('.')[1]
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/')
    const decoded = JSON.parse(
      Buffer.from(normalized, 'base64').toString('utf-8')
    )

    return decoded
  } catch (_e) {
    return null
  }
}

type DecodedJwt = {
  customerId: string
  sub: string
  iat: number
  exp: number
}

export const authOptions: AuthOptions = {
  providers: [
    CredentialsProvider({
      credentials: {
        username: {label: 'Kullanıcı Adı', type: 'text'},
        password: {label: 'Şifre', type: 'password'},
        accesstoken: {label: 'Token', type: 'text'},
        refreshToken: {label: 'Refresh Token', type: 'text'},
      },
      async authorize(credentials) {
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_API_URL}/authenticate`,
          {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
              username: credentials?.username,
              password: credentials?.password,
            }),
          }
        )

        if (!res.ok) {
          const errorResponse = await res.json()
          throw new Error(errorResponse.code || '')
        }

        const response = await res.json()

        const decodedToken = decodeJwt(response.token)

        if (!decodedToken?.customerId) {
          throw new Error('Invalid token')
        }

        return {
          id: decodedToken?.customerId,
          userId: decodedToken?.customerId,
          accessToken: response.token,
          refreshToken: response.refreshToken,
          expiresAt: Date.now() + 1000 * 60 * 20,
        }
      },
    }),
  ],

  session: {
    strategy: 'jwt',
  },

  callbacks: {
    async jwt({token, user, trigger, session}) {
      if (trigger === 'update') {
        token.accessToken = session?.user?.accessToken
        token.refreshToken = session?.user?.refreshToken
        token.userId = session?.user?.userId
        token.expiresAt = session?.user?.expiresAt
      }

      if (user) {
        token.accessToken = user.accessToken
        token.refreshToken = user.refreshToken
        token.userId = user.userId
        token.expiresAt = user.expiresAt
      }

      return token
    },

    async session({session, token}) {
      session.accessToken = token.accessToken
      session.refreshToken = token.refreshToken
      session.expiresAt = token.expiresAt
      session.userId = token.userId

      return session
    },
  },

  secret: process.env.NEXTAUTH_SECRET,
}
